<template>
  <section v-if="modelValue" class="mt-8 mb-8 boxed-button-grid">
    <label
      v-for="option in BacklogOption"
      :key="option"
      class="base-button"
      :class="{
        active: modelValue && modelValue.orderBacklogWorkReserve === option,
      }"
      >{{ wt('workReserve', 'option', option) }}
      <input
        type="radio"
        :value="option"
        v-model="modelValue.orderBacklogWorkReserve"
        :id="option"
        name="orderBacklogWorkReserve" />
    </label>
  </section>
</template>
<script lang="ts" setup>
import type { PropType } from 'vue'
import { BacklogOption } from '@/schemas/general/enums'
import { useWidgetText } from '@/helpers/useWidgetText'

interface OfficeWorkReserveForm {
  orderBacklogWorkReserve: BacklogOption
}

const { wt } = useWidgetText('widget-texts-office')
const modelValue = defineModel({ type: Object as PropType<OfficeWorkReserveForm> })
</script>
